export function loadWalkMeScript({ walkMeSrc }) {
  if (document.getElementById('walkmescript')) return;
  const script = document.createElement('script');
  script.id = 'walkmescript';
  script.type = 'text/javascript';
  script.async = true;
  script.src = walkMeSrc;
  window._walkmeConfig = {
    smartLoad: true,
    isContainedInIframe: true
  };
  document.head.appendChild(script);

  const scripts = document.getElementsByTagName('script');
  if (scripts.length > 0) {
    const referenceScript = scripts[0];
    referenceScript.parentNode.insertBefore(script, referenceScript);
  } else {
    document.head.appendChild(script);
  }
}

export function updateFortellisWalkMeData({ userData = {}, entityData = {} }) {
  window.Fortellis_WM_Variable = {
    orgId: entityData?.entity?.id || '',
    orgName: entityData?.entity?.name || '',
    fortellisOrgType: entityData?.entity?.fortellisDefinedType || '',
    userName: userData?.name || '',
    userEmail: userData?.email || ''
  };
}
